import { createAsyncThunk } from '@reduxjs/toolkit';

import { restartCurrentStepThunk } from '../../../../learn/slices/lesson/thunks/restart-current-step.thunk.ts';
import { refreshLastCompletedStepThunk } from '../../../../learn/slices/progress/thunks/refresh-last-completed-step.thunk.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';

import { selectUserAuthStatus } from '../../../selectors/user-auth-status.selector.ts';

import { fetchAndAssignChildProfileThunk } from '../../accounts/thunks/fetch-and-assign-child-profile.thunk.ts';
import { updateParentInfoVisibilityThunk } from '../../accounts/thunks/update-parent-info-visibility.thunk.ts';

import { AUTH_SLICE_NAME } from '../auth.slice.types.ts';

export const postInitialAuthenticationThunk = createAsyncThunk<void, void, ThunkApiConfigType>(
  `${AUTH_SLICE_NAME}/postInitialAuthentication`,
  async (_, thunkAPI) => {
    const isUserAuthenticated = selectUserAuthStatus(thunkAPI.getState());
    if (!isUserAuthenticated) {
      return;
    }

    await thunkAPI.dispatch(fetchAndAssignChildProfileThunk()).unwrap();
    await Promise.allSettled([
      thunkAPI.dispatch(refreshLastCompletedStepThunk()).unwrap(),
      thunkAPI.dispatch(updateParentInfoVisibilityThunk()).unwrap(),
    ]);
    await thunkAPI.dispatch(restartCurrentStepThunk()).unwrap();
  }
);
